/* No third-party dependencies, pop-ups, fake timers, or offer logic. */
(() => {
  if (customElements.get('bfs-gallery')) return;
  class BfsGallery extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.slides = [...this.querySelectorAll('.bfs-media')];
      this.thumbs = [...this.querySelectorAll('[data-slide]')];
      this.index = 0;
      this.querySelector('.bfs-gallery-arrows').hidden = this.slides.length < 2;
      this.querySelector('[data-prev]').addEventListener('click', () => this.show(this.index - 1));
      this.querySelector('[data-next]').addEventListener('click', () => this.show(this.index + 1));
      this.thumbs.forEach((button, i) => button.addEventListener('click', () => this.show(i)));
      let start;
      this.addEventListener('touchstart', e => { start = {x:e.changedTouches[0].clientX,y:e.changedTouches[0].clientY}; }, {passive:true});
      this.addEventListener('touchend', e => {
        if (!start || e.target.closest('video,iframe,model-viewer,.bfs-thumbnails')) return;
        const dx=e.changedTouches[0].clientX-start.x, dy=e.changedTouches[0].clientY-start.y;
        if (Math.abs(dx)>50 && Math.abs(dx)>Math.abs(dy)) this.show(this.index+(dx<0?1:-1));
        start=null;
      }, {passive:true});
      this.show(0);
      if(this.dataset.initialMedia)this.selectMedia(this.dataset.initialMedia);
    }
    show(index) {
      this.index=(index+this.slides.length)%this.slides.length;
      this.slides.forEach((slide,i) => {
        slide.hidden=i!==this.index;
        slide.style.display=i===this.index?'block':'none';
        if (i!==this.index) slide.querySelectorAll('video').forEach(video=>video.pause());
      });
      this.thumbs.forEach((button,i)=>button.setAttribute('aria-current',String(i===this.index)));
      const thumb=this.thumbs[this.index], track=this.querySelector('.bfs-thumbnails');
      if(thumb&&track) track.scrollTo({left:thumb.offsetLeft-track.offsetLeft-track.clientWidth/2+thumb.clientWidth/2,behavior:'instant'});
    }
    selectMedia(id) {
      const index=this.slides.findIndex(slide=>slide.dataset.mediaId===String(id));
      if(index>=0)this.show(index);
    }
  }
  class BfsProductForm extends HTMLElement {
    connectedCallback() {
      if(this.ready)return;
      this.ready=true;
      this.select=this.querySelector('[data-variants]');
      this.select?.addEventListener('change',()=>this.update(true));
      this.update(false);
    }
    update(navigate) {
      const option=this.select?.selectedOptions[0];
      if(!option)return;
      const available=option.dataset.available==='true';
      const button=this.querySelector('[name=add]');
      button.disabled=!available;
      this.querySelector('[data-button-label]').textContent=available?this.dataset.addLabel:this.dataset.soldLabel;
      const price=this.querySelector('[data-price]'), compare=this.querySelector('[data-compare]'), stock=this.querySelector('[data-stock]');
      if(price)price.textContent=option.dataset.price;
      if(compare){compare.textContent=option.dataset.compare;compare.hidden=!option.dataset.compare;}
      if(stock)stock.hidden=!available;
      const quantity=this.querySelector('[name=quantity]');
      if(quantity){
        quantity.min=option.dataset.min||'1';
        quantity.step=option.dataset.step||'1';
        if(option.dataset.max)quantity.max=option.dataset.max;else quantity.removeAttribute('max');
        if(navigate)quantity.value=quantity.min;
      }
      if(navigate){
        const url=new URL(location.href);url.searchParams.set('variant',option.value);history.replaceState({},'',url);
        this.closest('.bfs-product')?.querySelector('bfs-gallery')?.selectMedia(option.dataset.media);
      }
    }
  }
  class BfsCarousel extends HTMLElement {
    connectedCallback() {
      if(this.ready)return;
      this.ready=true;
      this.track=this.querySelector('.bfs-track');
      this.cards=[...this.querySelectorAll('[data-card]')];
      this.controls=this.querySelector('.bfs-carousel-controls');
      this.controls.hidden=this.cards.length<2;
      this.querySelector('[data-prev]').addEventListener('click',()=>this.move(-1));
      this.querySelector('[data-next]').addEventListener('click',()=>this.move(1));
      this.dots=this.querySelector('.bfs-dots');
      this.cards.forEach(()=>this.dots.appendChild(document.createElement('i')));
      this.cards.forEach(card=>{
        const button=card.querySelector('.bfs-read-more'),copy=card.querySelector('.bfs-comment-copy');
        if(!button||!copy||copy.textContent.trim().length<190)return;
        copy.classList.add('bfs-clamped');button.hidden=false;
        button.addEventListener('click',()=>{
          const expanded=button.getAttribute('aria-expanded')!=='true';
          copy.classList.toggle('bfs-clamped',!expanded);button.setAttribute('aria-expanded',String(expanded));
          button.textContent=expanded?button.dataset.less:button.dataset.more;
        });
      });
      this.track.addEventListener('scroll',()=>this.sync(),{passive:true});
      this.observer=new ResizeObserver(()=>this.sync());this.observer.observe(this.track);
      this.sync();
    }
    disconnectedCallback(){this.observer?.disconnect();}
    move(direction){
      if(!this.cards.length)return;
      const gap=parseFloat(getComputedStyle(this.track).gap)||0;
      const stride=this.cards[0].getBoundingClientRect().width+gap;
      const end=this.track.scrollWidth-this.track.clientWidth;
      let target=this.track.scrollLeft+direction*stride;
      if(direction>0&&this.track.scrollLeft>=end-2)target=0;
      if(direction<0&&this.track.scrollLeft<=2)target=end;
      this.track.scrollTo({left:target,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
    }
    sync(){
      if(!this.cards.length)return;
      const stride=this.cards[0].getBoundingClientRect().width+(parseFloat(getComputedStyle(this.track).gap)||0);
      const current=Math.round(this.track.scrollLeft/stride);
      [...this.dots.children].forEach((dot,i)=>dot.setAttribute('aria-current',String(i===current)));
      this.controls.hidden=this.track.scrollWidth<=this.track.clientWidth+2;
    }
    showBlock(target){
      const card=target.closest('[data-card]');if(!card)return;
      this.track.scrollTo({left:card.offsetLeft-this.cards[0].offsetLeft,behavior:'instant'});
    }
  }
  class BfsCountdown extends HTMLElement {
    connectedCallback(){
      const end=Date.parse(this.dataset.end);
      if(!Number.isFinite(end)){this.hidden=true;return;}
      const tick=()=>{
        const remaining=Math.max(0,Math.floor((end-Date.now())/1000));
        if(!remaining){this.textContent=this.dataset.expired;clearInterval(this.timer);return;}
        this.querySelector('[data-hours]').textContent=String(Math.floor(remaining/3600)).padStart(2,'0');
        this.querySelector('[data-minutes]').textContent=String(Math.floor(remaining/60)%60).padStart(2,'0');
        this.querySelector('[data-seconds]').textContent=String(remaining%60).padStart(2,'0');
      };
      tick();if(end>Date.now())this.timer=setInterval(tick,1000);
    }
    disconnectedCallback(){clearInterval(this.timer);}
  }
  customElements.define('bfs-gallery',BfsGallery);
  customElements.define('bfs-product-form',BfsProductForm);
  customElements.define('bfs-carousel',BfsCarousel);
  customElements.define('bfs-countdown',BfsCountdown);
  document.addEventListener('change',event=>{if(event.target.matches('[data-bfs-country]'))event.target.form.requestSubmit();});
  document.addEventListener('shopify:block:select',event=>{
    const target=event.target;
    const details=target.matches('details')?target:target.querySelector('details');if(details)details.open=true;
    const gallery=target.closest('bfs-gallery');if(gallery)gallery.selectMedia(target.dataset.mediaId);
    target.closest('bfs-carousel')?.showBlock(target);
  });
})();
